import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LargeTitle, Surface, Pill, AButton, Skeleton, StatCard, EmptyState } from "@/components/ios";
import { ShieldCheck, ShieldAlert, Flame, Waves, Zap, Check } from "lucide-react";
import { toast } from "sonner";

const ICON = { smoke_alarm: Flame, pool_cert: Waves, gas_electrical: Zap };

export default function Compliance() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/compliance").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const verify = async (id) => { await api.post(`/compliance/${id}/verify`); toast.success("Verified · renewed 12 months"); load(); };

  const expired = (items || []).filter((c) => c.status === "expired").length;
  const soon = (items || []).filter((c) => c.status === "due_soon").length;

  return (
    <div>
      <LargeTitle subtitle="Smoke alarms, pool certificates, gas & electrical safety">Compliance</LargeTitle>
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <StatCard icon={ShieldCheck} label="Total items" value={items?.length ?? "—"} />
        <StatCard icon={ShieldAlert} label="Expired gaps" value={expired} tone="danger" />
        <StatCard icon={ShieldAlert} label="Due within 30 days" value={soon} tone="warning" />
      </div>

      {!items ? <div className="space-y-3">{[0,1,2].map(i => <Skeleton key={i} className="h-16" />)}</div>
        : items.length === 0 ? <Surface><EmptyState icon={ShieldCheck} title="No compliance items" /></Surface>
        : <div className="space-y-3">
          {items.map((c) => {
            const Icon = ICON[c.kind] || ShieldCheck;
            const tone = c.status === "expired" ? "danger" : c.status === "due_soon" ? "warning" : "success";
            return (
              <Surface key={c.id} className="p-4 flex items-center gap-4" data-testid={`compliance-${c.id}`}>
                <div className="h-11 w-11 rounded-xl grid place-items-center shrink-0" style={{ background: `color-mix(in srgb, var(--${tone === "danger" ? "danger" : tone === "warning" ? "warning" : "success"}) 14%, transparent)` }}>
                  <Icon size={18} style={{ color: `var(--${tone === "danger" ? "danger" : tone === "warning" ? "warning" : "success"})` }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate" style={{ color: "var(--text)" }}>{c.name}</div>
                  <div className="text-sm text-secondary truncate">{c.property?.address} · expires {new Date(c.expires_at).toLocaleDateString("en-AU")}</div>
                </div>
                <Pill tone={tone}>{c.status.replace("_", " ")}</Pill>
                {c.status !== "ok" && <AButton variant="text" testid={`verify-${c.id}`} onClick={() => verify(c.id)}><Check size={14} className="inline" /> Verify</AButton>}
              </Surface>
            );
          })}
        </div>}
    </div>
  );
}
